import React from 'react'
import { isServer } from '../utils/platform'
import Config from '../config'
const isServerEnv = isServer()


// BugSnag config
let bugsnag: any;
let bugsnagReact: any;
let bugsnagClient: any;
let ErrorBoundary: any;

if (!isServerEnv) {
  bugsnag = require('@bugsnag/js')
  bugsnagReact = require('@bugsnag/plugin-react')
  bugsnagClient = bugsnag(Config.BUGSNAG_APIKEY)
  bugsnagClient.use(bugsnagReact, React)
  ErrorBoundary = bugsnagClient.getPlugin('react')
}

export default {
  bugsnagClient,
  ErrorBoundary
}